// Mock data for Nevzat ÇIRAK Portfolio

export const personalInfo = {
  name: "Nevzat ÇIRAK",
  title: "Lead Software Engineer",
  subtitle: "Backend / Platform / Security | IAM Interoperability Expert",
  email: "nevzatcirak17@gmail.com",
  location: "Ankara, Turkey",
  company: "HAVELSAN",
  bio: "Leading backend and platform engineering efforts for secure, scalable distributed systems. Architecting and implementing identity access management solutions with expertise in OAuth2, OpenID Connect, and policy-based authorization.",
  photo: "/nevzatcirak.JPG",
  logo: "/nev.svg",
  aiAssistant: {
    name: "NEVA",
    url: "https://ai.nevzatcirak.com",
    description: "My AI CV Assistant"
  },
  socialLinks: {
    github: "https://github.com/nevzatcirak",
    linkedin: "https://linkedin.com/in/nevzatcirak",
    twitter: "https://twitter.com/nevzatcirak",
    instagram: "https://instagram.com/nevzatcirak",
    medium: "https://medium.com/@nevzatcirak"
  },
  organizations: [
    { name: "Nevcodia IX", url: "https://github.com/nevcodia" },
    { name: "Shyntr", url: "https://github.com/Shyntr" }
  ]
};

export const expertise = [
  {
    id: 1,
    title: "Platform & Security",
    icon: "Shield",
    description: "Building secure, scalable distributed systems with zero-trust architectures",
    skills: [
      "Architecting secure, scalable distributed systems and cloud-native microservices",
      "Implementing Identity Access Management (IAM) solutions (OAuth2, OpenID Connect, AuthZEN)",
      "Developing with Java (Spring Boot), Golang, and Rust",
      "Policy-based authorization using OPA and zero-trust architectures",
      "Experience with Docker, Kafka, Traefik, PostgreSQL, and MongoDB"
    ]
  },
  {
    id: 2,
    title: "Full Stack Development",
    icon: "Code2",
    description: "End-to-end application development with modern technologies",
    skills: [
      "Designing and building secure, scalable applications end-to-end",
      "Developing responsive and modern UIs using ReactJS and TypeScript",
      "Building distributed backends, IAM systems and AI Agents using Java, Spring, Go and Rust",
      "Smart contract development on CosmWasm and EVM (Rust & Solidity)",
      "Integrating third-party and cloud-native services (AWS, DigitalOcean, Kafka, OPA)"
    ]
  },
  {
    id: 3,
    title: "Cloud Infrastructure",
    icon: "Cloud",
    description: "Designing and managing cloud-native architectures",
    skills: [
      "Architecting microservice-based and zero-trust compatible infrastructures",
      "Managing deployments, containerization, secrets, and service mesh",
      "Implementing CI/CD pipelines and automated security checks"
    ]
  }
];

export const techStack = [
  // Languages
  { name: "Java", category: "Languages" },
  { name: "Golang", category: "Languages" },
  { name: "TypeScript", category: "Languages" },
  { name: "JavaScript", category: "Languages" },
  { name: "Rust", category: "Languages" },
  // Frameworks
  { name: "Spring Boot", category: "Frameworks" },
  { name: "Spring Security", category: "Frameworks" },
  { name: "React", category: "Frameworks" },
  { name: "Gin", category: "Frameworks" },
  { name: "Hibernate", category: "Frameworks" },
  // Identity & Security
  { name: "OAuth 2.0", category: "Identity & Security" },
  { name: "OpenID Connect", category: "Identity & Security" },
  { name: "Ory Hydra", category: "Identity & Security" },
  { name: "OPA", category: "Identity & Security" },
  { name: "AuthZEN", category: "Identity & Security" },
  { name: "SSF", category: "Identity & Security" },
  // Infrastructure
  { name: "Docker", category: "Infrastructure" },
  { name: "Kafka", category: "Infrastructure" },
  { name: "Traefik", category: "Infrastructure" },
  { name: "CI/CD", category: "Infrastructure" },
  { name: "PostgreSQL", category: "Infrastructure" },
  { name: "MongoDB", category: "Infrastructure" },
  // Blockchain
  { name: "Solidity", category: "Blockchain" },
  { name: "CosmWasm", category: "Blockchain" }
];

export const experience = [
  {
    id: 1,
    company: "HAVELSAN",
    position: "Lead Software Engineer",
    subtitle: "Backend / Platform / Security",
    period: "October 2017 - Present",
    location: "Ankara, Turkey",
    description: "Leading backend and platform engineering efforts for secure, scalable distributed systems.",
    achievements: [
      "Architecting and implementing identity access management solutions using Spring Boot, OAuth2/OpenID Connect, policy-based authorization",
      "Building cloud-native microservices with Kafka and OPA integration",
      "Collaborating with cross-functional teams for platform reliability, observability, and delivery cadence",
      "Contributing full-stack expertise with React and TypeScript for UI components"
    ]
  },
  {
    id: 2,
    company: "Turkish Aerospace Industries (TAI)",
    position: "Avionics Integration Engineering Intern",
    period: "June 2016 - July 2016",
    location: "Ankara, Turkey",
    description: "Worked on avionics integration engineering projects during internship.",
    achievements: [
      "Gained hands-on experience in aerospace systems",
      "Collaborated with engineering teams on integration projects"
    ]
  }
];

export const education = {
  university: "Anadolu University",
  degree: "B.Eng in Electrical and Electronics Engineering",
  graduation: "June 2017",
  location: "Eskişehir, Turkey",
  gpa: "3.13/4.0"
};

export const contributions = [
  {
    organization: "OpenID Foundation",
    role: "Contributor",
    description: "Contributing to AuthZEN and Shared Signals Framework (SSF) Working Groups",
    icon: "Key"
  },
  {
    organization: "NATO MIP",
    role: "Contributor (8+ years)",
    description: "Contributing to Multilateral Interoperability Programme for defense coalition systems",
    icon: "Globe"
  }
];

export const projects = [
  // IAM & Security Category - Personal
  {
    id: 1,
    title: "Spring OAuth2 & OPA Integration",
    description: "Spring Boot Resource Server Application with Keycloak and Open Policy Agent configuration. Demonstrates policy-based authorization in microservices.",
    technologies: ["Java", "Spring Boot", "Keycloak", "OPA"],
    category: "IAM & Security",
    source: "Personal",
    stars: 11,
    link: "https://github.com/nevzatcirak/spring-oauth2-and-opa"
  },
  {
    id: 2,
    title: "React OIDC Client",
    description: "React component library using React Context API for authenticating with OpenID Connect. Simplifies OIDC integration in React applications.",
    technologies: ["TypeScript", "React", "OIDC", "Context API"],
    category: "IAM & Security",
    source: "Personal",
    stars: 5,
    link: "https://github.com/nevzatcirak/react-oidc-client"
  },
  {
    id: 3,
    title: "Traefik OAuth2 Middleware",
    description: "OAuth 2.0 Token Introspection Middleware for Traefik reverse proxy. Enables secure API gateway authentication.",
    technologies: ["Go", "Traefik", "OAuth2"],
    category: "IAM & Security",
    source: "Personal",
    stars: 1,
    link: "https://github.com/nevzatcirak/traefik-oauth2-middleware"
  },
  {
    id: 4,
    title: "OpenID Shared Signals Framework",
    description: "Reference implementation of OpenID Shared Signals Framework (SSF) for security event sharing between identity providers. Contributing to OpenID Foundation standards.",
    technologies: ["Java", "OpenID", "SSF", "Security Events"],
    category: "IAM & Security",
    source: "Personal",
    stars: 2,
    link: "https://github.com/nevzatcirak/sharedsignals"
  },
  // Organization Projects
  {
    id: 5,
    title: "Shyntr - Identity Broker",
    description: "Next-Generation Identity & Access Management. Protocol-agnostic Identity Broker connecting SAML, OIDC, and OAuth2 for Legacy, Modern, and Agentic AI.",
    technologies: ["Go", "Gin", "Ory Fosite", "OAuth2", "OIDC", "SAML"],
    category: "IAM & Security",
    source: "Shyntr",
    link: "https://github.com/Shyntr"
  },
  {
    id: 6,
    title: "SMART Hub",
    description: "Seamless Management of Access and Resource Transfer Hub - Comprehensive access management solution for enterprise resource control.",
    technologies: ["Go", "OAuth2", "Zero Trust"],
    category: "IAM & Security",
    source: "Nevcodia IX",
    stars: 1,
    link: "https://github.com/nevcodia/smarthub"
  },
  {
    id: 7,
    title: "Auth Worker",
    description: "OAuth2 Service Worker handler for seamless authentication flow management in modern web applications.",
    technologies: ["TypeScript", "Service Workers", "OAuth2"],
    category: "IAM & Security",
    source: "Nevcodia IX",
    link: "https://github.com/nevcodia/auth-worker"
  },
  // DevOps & Infrastructure
  {
    id: 8,
    title: "Portainer Stack Deployment",
    description: "GitHub Action for deploying stacks using Portainer API. Automates container orchestration and deployment workflows.",
    technologies: ["TypeScript", "GitHub Actions", "Portainer", "Docker"],
    category: "DevOps",
    source: "Nevcodia IX",
    stars: 1,
    link: "https://github.com/nevcodia/portainer-stack-deployment"
  },
  {
    id: 9,
    title: "Distributed Logging Stack",
    description: "Grafana LGTM Stack & SigNoz Deployment Examples for comprehensive observability in distributed systems.",
    technologies: ["Python", "Grafana", "Loki", "Tempo", "SigNoz"],
    category: "DevOps",
    source: "Personal",
    link: "https://github.com/nevzatcirak/distributed-logging"
  },
  {
    id: 10,
    title: "Go Gin Project Layout",
    description: "Opinionated Go GIN project layout and example for building scalable web applications with best practices.",
    technologies: ["Go", "Gin", "Clean Architecture"],
    category: "Backend",
    source: "Personal",
    link: "https://github.com/nevzatcirak/go-gin-project-layout"
  },
  // AI & Blockchain
  {
    id: 11,
    title: "NEVA - AI CV Assistant",
    description: "Personal AI assistant and digital twin project. Chat with NEVA to learn about my professional background, skills, and experience.",
    technologies: ["TypeScript", "AI", "LLM", "RAG"],
    category: "AI",
    source: "Personal",
    link: "https://ai.nevzatcirak.com"
  },
  {
    id: 12,
    title: "IX Smart Contract",
    description: "CosmWasm smart contract development for the IX ecosystem on Cosmos blockchain.",
    technologies: ["Rust", "CosmWasm", "Cosmos SDK"],
    category: "Blockchain",
    source: "Personal",
    link: "https://github.com/nevzatcirak/ix-smart-contract"
  }
];

export const stats = [
  { label: "Years at HAVELSAN", value: "8+" },
  { label: "GitHub Repos", value: "39" },
  { label: "Technologies", value: "25+" },
  { label: "NATO MIP Years", value: "8+" }
];

export const githubAchievements = [
  "Arctic Code Vault Contributor",
  "Pull Shark x2",
  "Developer Program Member",
  "GitHub Pro"
];

export const languages = [
  { name: "Turkish", level: "Native" },
  { name: "English", level: "Fluent" }
];
